import * as Yup from 'yup';

export const serviceRequirementsValidation = Yup.object().shape({
    salesConditions: Yup.object().shape({
        merchantCategoryCode: Yup.object()
            .shape({
                id: Yup.number(),
                code: Yup.string(),
                risk: Yup.string(),
                label: Yup.string(),
            })
            .nullable()
            .required('Select Merchant Category Code'),
        monthlyTurnover: Yup.number()
            .min(1, 'Monthly Turnover is required')
            .required('Monthly Turnover is required'),
    }),
    service: Yup.object().shape({
        serviceType: Yup.string().required('Select Service Type'),
        contractTerm: Yup.string().required('Select Contract Term'),
        transactionPricingOfferId: Yup.string().required('Select Transaction Pricing Offer'),
        selectedOnlineOffer: Yup.string()
            .when('serviceType', {
                is: (serviceType) => {
                    return serviceType === 'ONLINE';
                },
                then: Yup.string().required('Select Online Pricing Offer'),
            })
            .nullable(),
        selectedTerminalOffer: Yup.string()
            .when('serviceType', {
                is: (serviceType) => {
                    return serviceType === 'TERMINAL';
                },
                then: Yup.string().required('Select Terminal Pricing Offer'),
            })
            .nullable(),
        shouldApplyPromo: Yup.string(),
        promoOffer: Yup.string().when('shouldApplyPromo', {
            is: (val) => {
                return val === 'yes';
            },
            then: Yup.string().required('Select a promo offer'),
            otherwise: Yup.string(),
        }),
    }),
    order: Yup.object().shape({
        primaryProducts: Yup.array().of(
            Yup.object().shape({
                id: Yup.number().required('Product ID is required'),
                name: Yup.string().required('Product Name is required'),
                imageUrl: Yup.string().required('Product Image URL is required'),
                __typename: Yup.string().required('Product Type is required'),
            })
        ),
        secondaryProducts: Yup.array().of(
            Yup.object().shape({
                id: Yup.number().required('Product ID is required'),
                name: Yup.string().required('Product Name is required'),
                imageUrl: Yup.string().required('Product Image URL is required'),
                __typename: Yup.string().required('Product Type is required'),
            })
        ),
    }),
});
